import { cookieMgr } from '../utils'

export default class Selector {
	constructor(el) {
		this.$el = $(el);
		this.current = this.getCurrent();
		this.selectorName = 'categoryGroupSelector';
	}

	init() {
		this.$el.on('change', this.change.bind(this));

		var cookie = cookieMgr.get(this.selectorName);

		if (cookie) {
			this.setCurrent(cookie);
		} else {
			this.setCookie();
		}
	}

	getCurrent() {
		return this.$el.find(':selected').val()
	}
	setCurrent(current) {
		this.current = current;

		var self = this;
		this.$el.find('option').filter(function() {
			return $(this).val() == self.current;
		}).prop('selected', true);
	}

	change() {
		let url = location.protocol + '//' + location.host + '/';
		const locale = window.location.pathname.split('/')[1];

		if (['en', 'ru', 'es', 'jp', 'cn', 'it', 'nl'].indexOf(locale) !== -1) {
			url += locale + '/';
		}

		this.current = this.getCurrent();
		this.setCookie();

		window.location.href = url;
	}

	setCookie() {
		cookieMgr.set(this.selectorName, this.current, 365);
	}
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/components/selector.js